import { render, staticRenderFns } from "./CustomerContact.vue?vue&type=template&id=229ff0d2&scoped=true&"
import script from "./CustomerContact.vue?vue&type=script&lang=js&"
export * from "./CustomerContact.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContact.vue?vue&type=style&index=0&id=229ff0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229ff0d2",
  null
  
)

export default component.exports